import React from 'react';
import { Image } from 'semantic-ui-react';

import PhotoSlideShow from '../PhotoSlideShow/PhotoSlideShow';
import './PhotoCarouselNew.less';

class PhotoCarousel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openedImageIndex: -1
    }
  }

  render() {
    const { images } = this.props;
    const { openedImageIndex } = this.state;
    return (
      <div className={"image-gallary-contianer"}>
        <div className="section-header">
          {"Photos"}
        </div>
        <div className={"image-container"}>
          <Image.Group size='small' className="images-scroll">
            {images.map((image, i) => (
              <Image src={`${image.URL}`} key={image.URL+"-no-"+i}
                onClick={() => this.setState({ openedImageIndex: i })}
                style={{ maxHeight: '150px', width: 'auto' }}
              />
            ))}

            <PhotoSlideShow images={images} openedImageIndex={openedImageIndex} setOpenedIndex={(idx) => this.setState({ openedImageIndex: idx })} />

          </Image.Group>

        </div>

      </div>
    )
  }
}
export default PhotoCarousel;